import RouterSection from '@/layout/components/RouterSection'
export default {
  path: '/manager',
  name: 'manager_home',
  component: RouterSection,
  redirect: { name: 'ManagerMenu' },
  children: [
    {
      path: 'userManage',
      name: 'userManage',
      component: () => import('@/views/manager/UserManage.vue')
    },
    {
      path: 'program',
      name: 'ProgramManager',
      component: () => import('@/views/manager/ProgramManager.vue')
    },
    {
      path: 'system',
      name: 'SystemManager',
      component: () => import('@/views/manager/SystemManager.vue')
    },
    {
      path: 'menu',
      name: 'ManagerMenu',
      component: () => import('@/views/manager/ManagerMenu.vue')
    },
    {
      path: 'n-menu',
      name: 'ManagerMenu',
      component: () => import('@/views/manager/NewManagerMenu.vue')
    },
    {
      path: 'authmanage/auth-group',
      name: 'AuthGroupManager',
      component: () => import('@/views/manager/AuthGroupManager.vue')
    },
    {
      path: 'authmanage/auth-group-add-menu',
      name: 'AuthGroupAddMenu',
      component: () => import('@/views/manager/AuthGroupAddMenu.vue')
    },
    {
      path: 'authmanage/auth-add-user',
      name: 'AuthAddUser',
      component: () => import('@/views/manager/AuthAddUser.vue')
    },
    {
      path: 'authmanage/expanded-auth',
      name: 'ExpandedAuth',
      component: () => import('@/views/manager/ExpandedAuth.vue')
    },
    {
      path: 'authmanage/user-add-menu-auth',
      name: 'UserAddMenuAuth',
      component: () => import('@/views/manager/UserAddMenuAuth.vue')
    },
    {
      path: 'authmanage/user-auth',
      name: 'UserAuth',
      component: () => import('@/views/manager/UserAuth.vue')
    },
    {
      path: 'etc-user',
      name: 'etc-user',
      component: () => import('@/views/manager/EtcUser.vue')
    },
    {
      path: 'login-user-management',
      name: 'login-user-management',
      component: () => import('@/views/manager/LoginUserManagement.vue')
    },
    {
      path: 'menu-log-management',
      name: 'menu-log-management',
      component: () => import('@/views/manager/MenuLog.vue')
    },
    {
      path: 'commoncode',
      name: 'Commoncode',
      component: () => import('@/views/manager/Commoncode.vue'),
      meta: {
        asideView: false
      }
    },
    {
      path: 'login-log',
      name: 'LoginLog',
      component: () => import('@/views/manager/LoginLog.vue'),
      meta: {
        asideView: false
      }
    },
    {
      path: 'new-etc-org',
      name: 'NewEtcOrg',
      component: () => import('@/views/manager/NewEtcOrg.vue')
    },
    {
      path: 'auth',
      name: 'auth',
      component: RouterSection,
      children: [
        {
          path: 'group',
          name: 'ManagerGroupAuth',
          component: () => import('@/views/manager/ManagerGroupAuth.vue')
        },
        {
          path: 'menu-group',
          name: 'ManagerMenuGroupAuth',
          component: () => import('@/views/manager/ManagerMenuGroupAuth.vue')
        },
        {
          path: 'user-group',
          name: 'ManagerUserGroupAuth',
          component: () => import('@/views/manager/ManagerUserGroupAuth.vue')
        }
      ]
    },
    {
      path: 'user',
      name: 'ManagerUser',
      component: () => import('@/views/manager/ManagerUser.vue')
    }
  ]
}
